import { useEffect, useState, useContext } from "react";
import billService from "../../services/bill.service";
import styles from "./ListBills.module.css";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faEuroSign, faInbox } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../contexts/auth.context";
import { useNavigate } from "react-router-dom";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

function ListBillsPage() {
  const [bills, setBills] = useState([]);

  const { isAdmin, isTreasurer } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin && !isTreasurer) {
      navigate("/dashboard");
    }
    const fetchBills = async () => {
      const bills = await billService.getBills();

      setBills(bills.data);
    };

    fetchBills();
  }, [isAdmin, isTreasurer, navigate]);

  const handleDownload = (fileName) => {
    const link = document.createElement("a");
    link.download = "";
    link.target = "_blank";
    link.href = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleReceived = async (ev, id) => {
    ev.target.disabled = true;
    try {
      await billService.received(id);

      const newBills = bills.map((bill) =>
        bill._id === id ? { ...bill, received: true } : bill
      );

      setBills(newBills);
    } catch {
      ev.target.disabled = false;
    }
  };

  const handlePaid = async (ev, id) => {
    ev.target.disabled = true;
    try {
      await billService.paid(id);

      const newBills = bills.map((bill) =>
        bill._id === id ? { ...bill, paid: true } : bill
      );

      setBills(newBills);
    } catch {
      ev.target.disabled = false;
    }
  };

  return (
    <>
      <div className={styles["list-container"]}>
        <ScreenHeader title="Facturas" />
        <div className={styles["elementos-lista"]}>
          {bills.length ? (
            bills.map((bill) => (
              <div className={styles.elemento} key={bill._id}>
                <div className={styles["card-header"]}>
                  <div className={styles.fecha}>
                    {dayjs(bill.createdAt).format("DD-MM-YYYY")}
                  </div>
                  <div className={styles.email}>{bill.user}</div>
                </div>
                <div className={styles.descripcion}>{bill.description}</div>
                <div className={styles.acciones}>
                  <button
                    className={styles["download-button"]}
                    onClick={() => handleDownload(bill.fileName)}
                  >
                    <FontAwesomeIcon icon={faArrowDown} />
                  </button>

                  <button
                    className={styles["received-button"]}
                    onClick={(ev) => handleReceived(ev, bill._id)}
                    disabled={bill.received || !isTreasurer}
                  >
                    <FontAwesomeIcon icon={faInbox} />
                    {bill.received ? " Recibido" : " ¿Recibido?"}
                  </button>

                  <button
                    className={styles["paid-button"]}
                    onClick={(ev) => handlePaid(ev, bill._id)}
                    disabled={bill.paid || !isTreasurer}
                  >
                    <FontAwesomeIcon icon={faEuroSign} />
                    {bill.paid ? " Pagado" : " ¿Pagado?"}
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p>Aún no hay facturas subidas</p>
          )}
        </div>
      </div>
    </>
  );
}

export default ListBillsPage;
